"use strict";
const allButtonsAssinar = document.querySelectorAll('.cacm-produto-card__botao-assinar');
const minicart = document.querySelector('.cacm-minicartassinatura');
const botaoFecharMinicart = document.querySelector('.cacm-minicartassinatura__fechar');
const toast = document.getElementById('cacm-toast');
const carrinhoOffcanvas = document.getElementById('cacm-carrinho-offcanvas');
const botaoFecharCarrinho = document.getElementById('cacm-carrinho-fechar');
const botaoVerCarrinho = document.querySelector('.cacm-minicartassinatura__botao');
const containerProdutosCarrinho = document.getElementById('cacm-carrinho-produtos');
const totalCarrinho = document.getElementById('cacm-carrinho-total');
const itensCarrinho = document.getElementById('cacm-carrinho-itens');
const botaoAssinarCarrinho = document.querySelector('.cacm-carrinho-offcanvas__botao-assinar');
// Elementos do minicart
const resumoMinicart = document.querySelector('.cacm-minicartassinatura__resumo-valor');
class Produto {
    id;
    nome;
    preco;
    precoOriginal;
    imagem;
    quantidade;
    constructor(id, nome, preco, precoOriginal, imagem, quantidade) {
        this.id = id;
        this.nome = nome;
        this.preco = preco;
        this.precoOriginal = precoOriginal;
        this.imagem = imagem;
        this.quantidade = quantidade;
    }
}
let casrtAssinatura = [];

// Mapa variantId -> categoria (graos, moido, capsula, drip) para mensagem de desconto ESPECIAL
function construirMapaCategoriaPorVariantId() {
    const mapa = {};
    const cards = document.querySelectorAll(".cacm-produto-card[data-id][data-categoria]");
    cards.forEach((card) => {
        const id = card.getAttribute("data-id");
        const categoria = card.getAttribute("data-categoria");
        if (id && categoria)
            mapa[String(id)] = categoria;
    });
    return mapa;
}

function carrinhoTemDripOuCapsula() {
    const mapa = construirMapaCategoriaPorVariantId();
    return casrtAssinatura.some((p) => {
        const cat = mapa[String(p.id)];
        return cat === "drip" || cat === "capsula";
    });
}

function atualizarTextoDescontoEspecial() {
    const eh40 = carrinhoTemDripOuCapsula();
    const textoPopup = eh40 ? "40% OFF" : "25% OFF";
    const textoBanner = eh40 ? "Até 40% OFF + FRETE GRÁTIS" : "Até 25% OFF + FRETE GRÁTIS";
    const elPopup = document.getElementById("cacm-popup-desconto-valor");
    const elMinicart = document.getElementById("cacm-minicart-desconto-valor");
    const elCarrinho = document.getElementById("cacm-carrinho-desconto-valor");
    if (elPopup)
        elPopup.textContent = textoPopup;
    if (elMinicart)
        elMinicart.textContent = textoBanner;
    if (elCarrinho)
        elCarrinho.textContent = textoBanner;
}

// Funções para persistência no sessionStorage
function salvarCarrinhoNoSessionStorage() {
    try {
        sessionStorage.setItem('carrinhoAssinaturaMensal', JSON.stringify(casrtAssinatura));
    }
    catch (error) {
        console.error('Erro ao salvar carrinho no sessionStorage:', error);
    }
}
function recuperarCarrinhoDoSessionStorage() {
    try {
        const carrinhoSalvo = sessionStorage.getItem('carrinhoAssinaturaMensal');
        if (carrinhoSalvo) {
            const produtosRecuperados = JSON.parse(carrinhoSalvo);
            // Converter de volta para objetos Produto
            return produtosRecuperados.map((produto) => new Produto(produto.id, produto.nome, produto.preco, produto.precoOriginal, produto.imagem, produto.quantidade));
        }
    }
    catch (error) {
        console.error('Erro ao recuperar carrinho do sessionStorage:', error);
    }
    return [];
}
// Função para mostrar toast
function mostrarToast(mensagem) {
    const toastMessage = toast.querySelector('.cacm-toast__message');
    toastMessage.textContent = mensagem;
    toast.classList.add('show');
    setTimeout(() => {
        toast.classList.remove('show');
    }, 3000);
}
// Função para desabilitar botão temporariamente
function desabilitarBotaoTemporariamente(botao, tempo = 2000) {
    botao.setAttribute('disabled', 'true');
    botao.textContent = 'Adicionando...';
    setTimeout(() => {
        botao.removeAttribute('disabled');
        botao.textContent = 'Assinar';
    }, tempo);
}
// Função para mostrar minicart
function mostrarMinicart() {
    if (minicart) {
        minicart.style.display = 'block';
        atualizarMinicart();
    }
}
// Função para fechar minicart
function fecharMinicart() {
    if (minicart) {
        minicart.style.display = 'none';
    }
}
// Função para atualizar contador do header
function atualizarContadorHeader(totalItens) {
    if (contadorCarrinhoHeader) {
        contadorCarrinhoHeader.textContent = totalItens.toString();
        if (totalItens > 0) {
            contadorCarrinhoHeader.classList.add('show');
        }
        else {
            contadorCarrinhoHeader.classList.remove('show');
        }
    }
}
// Função para atualizar minicart
function atualizarMinicart() {
    const totalItens = casrtAssinatura.reduce((total, produto) => total + parseInt(produto.quantidade), 0);
    // Calcular total baseado nos preços individuais dos produtos
    const totalPreco = casrtAssinatura.reduce((total, produto) => {
        const precoProduto = parseFloat(produto.preco.replace('R$', '').replace(',', '.').trim());
        const quantidade = parseInt(produto.quantidade);
        return total + (precoProduto * quantidade);
    }, 0);
    // Adicionar frete fixo de R$7,99
    const freteFixo = 7.99;
    const totalComFrete = totalPreco + freteFixo;
    // Atualizar contador do header
    atualizarContadorHeader(totalItens);
    // Atualizar resumo do minicart
    if (resumoMinicart) {
        resumoMinicart.textContent = `R$ ${totalComFrete.toFixed(2).replace('.', ',')} / ${totalItens} itens`;
    }
    atualizarTextoDescontoEspecial();
}
// Função para montar URL do carrinho
function montarUrlCarrinho() {
    const baseUrl = 'https://coffeemais.com/cart/';
    const parametros = casrtAssinatura.map(item => `${item.id}:${item.quantidade}`).join(',');
    const urlFinal = baseUrl + parametros;
    return urlFinal;
}
// Função para abrir carrinho off-canvas
function abrirCarrinho() {
    if (carrinhoOffcanvas) {
        carrinhoOffcanvas.classList.add('show');
        renderizarProdutosCarrinho();
        setTimeout(() => {
            verificarConteudoAdicional();
        }, 400);
        setTimeout(() => {
            verificarConteudoAdicional();
        }, 800);
    }
}
// Função para fechar carrinho off-canvas
function fecharCarrinho() {
    if (carrinhoOffcanvas) {
        carrinhoOffcanvas.classList.remove('show');
    }
}
// Função para renderizar produtos no carrinho
function renderizarProdutosCarrinho() {
    if (!containerProdutosCarrinho)
        return;
    containerProdutosCarrinho.innerHTML = '';
    if (casrtAssinatura.length === 0) {
        containerProdutosCarrinho.innerHTML = '<p style="color: #999; text-align: center; padding: 20px;">Carrinho vazio</p>';
        atualizarResumoCarrinho();
        return;
    }
    casrtAssinatura.forEach((produto, index) => {
        const itemElement = document.createElement('div');
        itemElement.className = 'cacm-carrinho-item';
        itemElement.setAttribute('data-index', index.toString());
        itemElement.innerHTML = `
            <div class="cacm-carrinho-item__coluna-foto">
                <img src="${produto.imagem}" alt="${produto.nome}" class="cacm-carrinho-item__imagem">
            </div>
            <div class="cacm-carrinho-item__coluna-nome">
                <div class="cacm-carrinho-item__nome">${produto.nome}</div>
            </div>
            <div class="cacm-carrinho-item__coluna-quantidade">
                <div class="cacm-carrinho-item__quantidade">
                    <button class="cacm-carrinho-item__quantidade-botao" data-action="diminuir">-</button>
                    <span class="cacm-carrinho-item__quantidade-valor">${produto.quantidade}</span>
                    <button class="cacm-carrinho-item__quantidade-botao" data-action="aumentar">+</button>
                </div>
            </div>
        `;
        containerProdutosCarrinho.appendChild(itemElement);
    });
    // Adicionar event listeners para os botões de quantidade
    adicionarEventListenersQuantidadeCarrinho();
    atualizarResumoCarrinho();
    atualizarTextoDescontoEspecial();
    setTimeout(() => {
        verificarConteudoAdicional();
    }, 100);
    setTimeout(() => {
        verificarConteudoAdicional();
    }, 300);
}
function verificarConteudoAdicional() {
    const bodyElement = document.querySelector('.cacm-carrinho-offcanvas__body');
    const footerElement = document.querySelector('.cacm-carrinho-offcanvas__footer');
    if (!bodyElement || !footerElement) {
        return;
    }
    const scrollTop = bodyElement.scrollTop;
    const clientHeight = bodyElement.clientHeight;
    const scrollHeight = bodyElement.scrollHeight;
    const hasScroll = scrollHeight > clientHeight;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
    const remainingScroll = scrollHeight - (scrollTop + clientHeight);
    const hasMoreContentBelow = remainingScroll > 10;
    if (hasScroll && hasMoreContentBelow) {
        footerElement.classList.add('has-more-content');
    }
    else {
        footerElement.classList.remove('has-more-content');
    }
}
// Função para adicionar event listeners aos botões de quantidade do carrinho
function adicionarEventListenersQuantidadeCarrinho() {
    const botoesQuantidade = containerProdutosCarrinho.querySelectorAll('.cacm-carrinho-item__quantidade-botao');
    botoesQuantidade.forEach(botao => {
        botao.addEventListener('click', (e) => {
            const action = e.target.dataset.action;
            const itemElement = e.target.closest('.cacm-carrinho-item');
            const index = parseInt(itemElement?.getAttribute('data-index') || '0');
            if (action === 'aumentar') {
                aumentarQuantidadeCarrinho(index);
            }
            else if (action === 'diminuir') {
                diminuirQuantidadeCarrinho(index);
            }
        });
    });
}
// Função para aumentar quantidade no carrinho
function aumentarQuantidadeCarrinho(index) {
    if (casrtAssinatura[index]) {
        const quantidadeAtual = parseInt(casrtAssinatura[index].quantidade);
        casrtAssinatura[index].quantidade = (quantidadeAtual + 1).toString();
        salvarCarrinhoNoSessionStorage(); // Salvar no sessionStorage
        renderizarProdutosCarrinho();
        atualizarMinicart();
        mostrarToast('Quantidade atualizada!');
    }
}
// Função para diminuir quantidade no carrinho
function diminuirQuantidadeCarrinho(index) {
    if (casrtAssinatura[index]) {
        const quantidadeAtual = parseInt(casrtAssinatura[index].quantidade);
        if (quantidadeAtual > 1) {
            casrtAssinatura[index].quantidade = (quantidadeAtual - 1).toString();
            salvarCarrinhoNoSessionStorage(); // Salvar no sessionStorage
            renderizarProdutosCarrinho();
            atualizarMinicart();
            mostrarToast('Quantidade atualizada!');
        }
        else {
            // Remove o item se a quantidade chegar a zero
            casrtAssinatura.splice(index, 1);
            salvarCarrinhoNoSessionStorage(); // Salvar no sessionStorage
            renderizarProdutosCarrinho();
            atualizarMinicart();
            mostrarToast('Produto removido do carrinho!');
            // Fecha o carrinho se estiver vazio
            if (casrtAssinatura.length === 0) {
                setTimeout(() => {
                    fecharCarrinho();
                }, 1500);
            }
        }
    }
}
// Função para atualizar resumo do carrinho
function atualizarResumoCarrinho() {
    const totalItens = casrtAssinatura.reduce((total, produto) => total + parseInt(produto.quantidade), 0);
    // Calcular total baseado nos preços individuais dos produtos
    const totalPreco = casrtAssinatura.reduce((total, produto) => {
        const precoProduto = parseFloat(produto.preco.replace('R$', '').replace(',', '.').trim());
        const quantidade = parseInt(produto.quantidade);
        return total + (precoProduto * quantidade);
    }, 0);
    // Adicionar frete fixo de R$7,99
    const freteFixo = 7.99;
    const totalComFrete = totalPreco + freteFixo;
    if (totalCarrinho) {
        totalCarrinho.textContent = `R$ ${totalComFrete.toFixed(2).replace('.', ',')}`;
    }
    if (itensCarrinho) {
        itensCarrinho.textContent = totalItens.toString();
    }
    // Atualizar o link do botão ASSINAR
    if (botaoAssinarCarrinho) {
        const linkAssinar = botaoAssinarCarrinho.closest('a');
        if (linkAssinar) {
            const urlCarrinho = montarUrlCarrinho();
            linkAssinar.href = urlCarrinho;
        }
    }
}
allButtonsAssinar.forEach(button => {
    button.addEventListener('click', () => {
        const card = button.closest('.cacm-produto-card');
        if (!card)
            return;
        const produtoId = card.getAttribute('data-id') || '';
        const quantidadeCard = parseInt(card.querySelector('.cacm-produto-card__quantidade-valor')?.textContent || '1');
        // Verificar se o produto já existe no carrinho
        const produtoExistente = casrtAssinatura.find(p => p.id === produtoId);
        if (produtoExistente) {
            // Se o produto já existe, somar a quantidade
            const quantidadeAtual = parseInt(produtoExistente.quantidade);
            produtoExistente.quantidade = (quantidadeAtual + quantidadeCard).toString();
            salvarCarrinhoNoSessionStorage(); // Salvar no sessionStorage
            mostrarToast(`Quantidade atualizada! Total: ${produtoExistente.quantidade}`);
            if (carrinhoOffcanvas && carrinhoOffcanvas.classList.contains('show')) {
                renderizarProdutosCarrinho();
                setTimeout(() => {
                    verificarConteudoAdicional();
                }, 150);
                setTimeout(() => {
                    verificarConteudoAdicional();
                }, 500);
            }
        }
        else {
            // Se é um produto novo, adicionar ao carrinho
            const produto = new Produto(produtoId, card.querySelector('.cacm-produto-card__nome')?.textContent || '', card.querySelector('.cacm-produto-card__preco-atual')?.textContent || '', card.querySelector('.cacm-produto-card__preco-original')?.textContent || '', card.querySelector('.cacm-produto-card__imagem')?.getAttribute('src') || '', quantidadeCard.toString());
            casrtAssinatura.push(produto);
            salvarCarrinhoNoSessionStorage(); // Salvar no sessionStorage
            mostrarToast('Produto adicionado ao carrinho!');
        }
        mostrarMinicart();
        desabilitarBotaoTemporariamente(button);
    });
});
// Event listener para fechar minicart
if (botaoFecharMinicart) {
    botaoFecharMinicart.addEventListener('click', fecharMinicart);
}
// Event listener para abrir carrinho off-canvas
if (botaoVerCarrinho) {
    botaoVerCarrinho.addEventListener('click', (e) => {
        e.preventDefault();
        abrirCarrinho();
    });
}
// Event listener para fechar carrinho off-canvas
if (botaoFecharCarrinho) {
    botaoFecharCarrinho.addEventListener('click', fecharCarrinho);
}
// Event listener para fechar carrinho ao clicar no overlay
if (carrinhoOffcanvas) {
    const overlay = carrinhoOffcanvas.querySelector('.cacm-carrinho-offcanvas__overlay');
    if (overlay) {
        overlay.addEventListener('click', fecharCarrinho);
    }
    const bodyElement = carrinhoOffcanvas.querySelector('.cacm-carrinho-offcanvas__body');
    if (bodyElement) {
        let scrollTimeout;
        bodyElement.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                verificarConteudoAdicional();
            }, 10);
        });
        window.addEventListener('resize', () => {
            if (carrinhoOffcanvas.classList.contains('show')) {
                setTimeout(() => {
                    verificarConteudoAdicional();
                }, 100);
            }
        });
    }
}
const allButtonsQuantidade = document.querySelectorAll('.cacm-produto-card__quantidade-botao');
allButtonsQuantidade.forEach(button => {
    button.addEventListener('click', () => {
        const container = button.closest('.cacm-produto-card__quantidade-container');
        const valorElement = container?.querySelector('.cacm-produto-card__quantidade-valor');
        let valor = parseInt(valorElement?.textContent || '0');
        if (button.textContent === '+') {
            valor += 1;
        }
        else if (button.textContent === '-') {
            valor -= 1;
            if (valor < 1)
                valor = 1;
        }
        valorElement.textContent = valor.toString();
    });
});
// FAQ Colapsável
const faqPerguntas = document.querySelectorAll('.cacm-faq-item__pergunta');
faqPerguntas.forEach(pergunta => {
    pergunta.addEventListener('click', () => {
        const faqItem = pergunta.closest('.cacm-faq-item');
        const resposta = faqItem?.querySelector('.cacm-faq-item__resposta');
        const icone = pergunta.querySelector('.cacm-faq-item__icone');
        if (!faqItem || !resposta || !icone)
            return;
        const isExpanded = pergunta.getAttribute('aria-expanded') === 'true';
        // Fecha todos os outros itens
        faqPerguntas.forEach(outraPergunta => {
            if (outraPergunta !== pergunta) {
                const outroItem = outraPergunta.closest('.cacm-faq-item');
                const outraResposta = outroItem?.querySelector('.cacm-faq-item__resposta');
                const outroIcone = outraPergunta.querySelector('.cacm-faq-item__icone');
                if (outraResposta && outroIcone) {
                    outraPergunta.setAttribute('aria-expanded', 'false');
                    outraResposta.classList.remove('active');
                }
            }
        });
        // Alterna o item atual
        if (isExpanded) {
            pergunta.setAttribute('aria-expanded', 'false');
            resposta.classList.remove('active');
        }
        else {
            pergunta.setAttribute('aria-expanded', 'true');
            resposta.classList.add('active');
        }
    });
});
document.addEventListener('DOMContentLoaded', () => {
    casrtAssinatura = recuperarCarrinhoDoSessionStorage();
    atualizarMinicart();
    atualizarTextoDescontoEspecial();
    configurarModalProduto();
});
// Modal de informações do produto
const modalProduto = document.getElementById('cacm-produto-modal');
const botaoFecharModal = document.getElementById('cacm-produto-modal-fechar');
const modalImagem = document.getElementById('cacm-produto-modal-imagem');
const modalTitulo = document.getElementById('cacm-produto-modal-titulo');
// Header carrinho
const botaoCarrinhoHeader = document.getElementById('cacm-header-carrinho-botao');
const contadorCarrinhoHeader = document.getElementById('cacm-header-carrinho-contador');
function configurarModalProduto() {
    const cardsProduto = document.querySelectorAll('.cacm-produto-card');
    cardsProduto.forEach(card => {
        const imagemContainer = card.querySelector('.cacm-produto-card__imagem-container');
        const titulo = card.querySelector('.cacm-produto-card__nome');
        if (imagemContainer && titulo) {
            const areaClicavel = document.createElement('div');
            areaClicavel.className = 'cacm-produto-card__area-clicavel';
            imagemContainer.parentNode?.insertBefore(areaClicavel, imagemContainer);
            areaClicavel.appendChild(imagemContainer);
            areaClicavel.appendChild(titulo);
            areaClicavel.addEventListener('click', () => {
                abrirModalProduto(card);
            });
        }
        const lupaOverlay = card.querySelector('.cacm-produto-card__lupa-overlay');
        if (lupaOverlay) {
            lupaOverlay.addEventListener('click', (e) => {
                e.stopPropagation();
                abrirModalProduto(card);
            });
        }
    });
}
function addBlur() {
    const allSections = document.querySelectorAll('section');
    allSections.forEach(section => {
        section.classList.add('blur-section');
    });
}
function removeBlur() {
    const allSections = document.querySelectorAll('section');
    allSections.forEach(section => {
        section.classList.remove('blur-section');
    });
}
function abrirModalProduto(card) {
    const imagem = card.querySelector('.cacm-produto-card__imagem');
    const titulo = card.querySelector('.cacm-produto-card__nome');
    const productId = card.getAttribute('data-id');
    if (modalImagem && modalTitulo && imagem && titulo) {
        modalImagem.src = imagem.src;
        modalImagem.alt = imagem.alt;
        modalTitulo.textContent = titulo.textContent;
        if (productId) {
            carregarMetafieldsProduto(productId);
        }
        modalProduto.classList.add('show');
        document.body.style.overflow = 'hidden';
        addBlur();
    }
}
async function carregarMetafieldsProduto(productId) {
    try {
        const card = document.querySelector(`[data-id="${productId}"]`);
        if (card) {
            const metafields = {
                descricao_curta: card.getAttribute('data-descricao-curta') || 'Não informado',
                regiao: card.getAttribute('data-regiao') || 'Não informado',
                notas_sensoriais: card.getAttribute('data-notas-sensoriais') || 'Não informado',
                torra: card.getAttribute('data-torra') || 'Não informado',
                variedade: card.getAttribute('data-variedade') || 'Não informado',
                descricao_completa: card.getAttribute('data-descricao-completa') || 'Não informado'
            };
            atualizarCamposModalComMetafields(metafields);
        }
        else {
            atualizarCamposModalComProduto({});
        }
    }
    catch (error) {
        console.error('Erro ao carregar metafields:', error);
        atualizarCamposModalComProduto({});
    }
}
function atualizarCamposModalComMetafields(metafields) {
    const descricaoCurta = document.getElementById('cacm-produto-modal-descricao-curta');
    const regiao = document.getElementById('cacm-produto-modal-regiao');
    const notas = document.getElementById('cacm-produto-modal-notas');
    const torra = document.getElementById('cacm-produto-modal-torra');
    const tipo = document.getElementById('cacm-produto-modal-tipo');
    const descricaoCompleta = document.getElementById('cacm-produto-modal-descricao');
    if (descricaoCurta) {
        const descricao = metafields.descricao_curta;
        descricaoCurta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição do produto será carregada aqui.'}</p>`;
    }
    if (regiao) {
        regiao.textContent = metafields.regiao;
    }
    if (notas) {
        notas.textContent = metafields.notas_sensoriais;
    }
    if (torra) {
        torra.textContent = metafields.torra;
    }
    if (tipo) {
        tipo.textContent = metafields.variedade;
    }
    if (descricaoCompleta) {
        const descricao = metafields.descricao_completa;
        descricaoCompleta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição completa do produto será carregada aqui.'}</p>`;
    }
}
function atualizarCamposModalComProduto(product) {
    const descricaoCurta = document.getElementById('cacm-produto-modal-descricao-curta');
    const regiao = document.getElementById('cacm-produto-modal-regiao');
    const notas = document.getElementById('cacm-produto-modal-notas');
    const torra = document.getElementById('cacm-produto-modal-torra');
    const tipo = document.getElementById('cacm-produto-modal-tipo');
    const descricaoCompleta = document.getElementById('cacm-produto-modal-descricao');
    const getMetafield = (namespace, key) => {
        if (product.metafields) {
            const metafield = product.metafields.find((m) => m.namespace === namespace && m.key === key);
            return metafield ? metafield.value : 'Não informado';
        }
        return 'Não informado';
    };
    if (descricaoCurta) {
        const descricao = getMetafield('custom', 'descricao_curta');
        descricaoCurta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição do produto será carregada aqui.'}</p>`;
    }
    if (regiao) {
        regiao.textContent = getMetafield('custom', 'regiao');
    }
    if (notas) {
        notas.textContent = getMetafield('custom', 'notas_sensoriais');
    }
    if (torra) {
        torra.textContent = getMetafield('custom', 'torra');
    }
    if (tipo) {
        tipo.textContent = getMetafield('custom', 'tipo');
    }
    if (descricaoCompleta) {
        const descricao = getMetafield('custom', 'descricao_completa');
        descricaoCompleta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição completa do produto será carregada aqui.'}</p>`;
    }
}
function fecharModalProduto() {
    modalProduto.classList.remove('show');
    removeBlur();
    document.body.style.overflow = '';
}
if (botaoFecharModal) {
    botaoFecharModal.addEventListener('click', fecharModalProduto);
}
if (modalProduto) {
    const overlay = modalProduto.querySelector('.cacm-produto-modal__overlay');
    if (overlay) {
        overlay.addEventListener('click', fecharModalProduto);
    }
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalProduto.classList.contains('show')) {
            fecharModalProduto();
        }
    });
}
if (botaoCarrinhoHeader) {
    botaoCarrinhoHeader.addEventListener('click', () => {
        abrirCarrinho();
    });
}
const popupEspecial = document.getElementById('cacm-popup-especial');
const botaoFecharPopupEspecial = document.getElementById('cacm-popup-especial-fechar');
const botaoPopupEspecial = document.getElementById('cacm-popup-especial-botao');
const botaoQueroMinicart = document.getElementById('cacm-banner-quero-minicart');
const botaoQueroCarrinho = document.getElementById('cacm-banner-quero-carrinho');
function abrirPopupEspecial() {
    if (popupEspecial) {
        atualizarTextoDescontoEspecial();
        if (minicart && minicart.style.display === 'block') {
            fecharMinicart();
        }
        if (carrinhoOffcanvas && carrinhoOffcanvas.classList.contains('show')) {
            fecharCarrinho();
        }
        popupEspecial.classList.add('show');
        document.body.style.overflow = 'hidden';
        addBlur();
    }
}
function fecharPopupEspecial() {
    if (popupEspecial) {
        popupEspecial.classList.remove('show');
        removeBlur();
        document.body.style.overflow = '';
    }
}
if (botaoQueroMinicart) {
    botaoQueroMinicart.addEventListener('click', (e) => {
        e.preventDefault();
        abrirPopupEspecial();
    });
}
if (botaoQueroCarrinho) {
    botaoQueroCarrinho.addEventListener('click', (e) => {
        e.preventDefault();
        abrirPopupEspecial();
    });
}
if (botaoFecharPopupEspecial) {
    botaoFecharPopupEspecial.addEventListener('click', fecharPopupEspecial);
}
if (popupEspecial) {
    const overlay = popupEspecial.querySelector('.cacm-popup-especial__overlay');
    if (overlay) {
        overlay.addEventListener('click', fecharPopupEspecial);
    }
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popupEspecial.classList.contains('show')) {
            fecharPopupEspecial();
        }
    });
}
function getUrlPaginaAnual() {
    return window.location.origin + '/pages/clube-coffee-mais-assinatura-anual';
}
function salvarCarrinhoMigracaoERedirecionarAnual() {
    try {
        const payload = [];
        casrtAssinatura.forEach((item) => {
            const card = document.querySelector(`.cacm-produto-card[data-id="${item.id}"]`);
            const annualVariantId = card ? card.getAttribute('data-related-annual-variant-id') : null;
            if (annualVariantId) {
                payload.push({ id: annualVariantId, quantidade: item.quantidade });
            }
            else if (card && !annualVariantId) {
                console.warn("Migração: produto no carrinho sem produto anual associado (metafield custom.produto_relacionado).", item.nome, "Variant ID:", item.id);
            }
        });
        if (payload.length === 0 && casrtAssinatura.length > 0) {
            console.warn("Migração: nenhum item do carrinho tem produto anual vinculado. Verifique o metafield custom.produto_relacionado nos produtos mensais.");
        }
        sessionStorage.setItem('carrinhoMigracaoMensalParaAnual', JSON.stringify(payload));
    }
    catch (e) {
        console.error('Erro ao salvar carrinho para migração:', e);
    }
    window.location.href = getUrlPaginaAnual();
}
if (botaoPopupEspecial) {
    botaoPopupEspecial.addEventListener('click', () => {
        salvarCarrinhoMigracaoERedirecionarAnual();
    });
}
document.addEventListener('click', (e) => {
    const linkEspecial = e.target.closest('a.cacm-produto-card__label-especial');
    if (linkEspecial && linkEspecial.href) {
        e.preventDefault();
        salvarCarrinhoMigracaoERedirecionarAnual();
    }
});
